var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSwitch !== '3')?_c('div',{staticClass:"button temr"},[_c('van-button',{class:_vm.disabled ? 'gray' : '',attrs:{"type":"danger","loading":_vm.loading,"loadingText":_vm.loadingText},on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.text))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }